import { ready } from '../helpers/jQueryReplacements';

ready(() => {
  const $stateSelectLabel = $('label[for="id_company_state_territory"]');
  const $stateSelect = $('#id_company_state_territory');
  const $stateSelectedValue = $('#id_company_state_territory :selected').val();
  const $countrySelect = $('#id_company_country');
  let $countrySelectedValue = $('#id_company_country :selected').val();

  const showStateDropdown = () => {
    $stateSelectLabel.css('display', 'unset');
    $stateSelect.css('display', 'unset');
    $stateSelect.prop('required', true);
  };

  const hideStateDropdown = () => {
    $stateSelect.prop('required', false);
    $stateSelectLabel.css('display', 'none');
    $stateSelect.css('display', 'none');
  };

  // Hide state select widget and label on pageload. If the selected value is not
  // 'United States' or a blank string we want to hide the state dropdown. This
  // handles the case that someone is editing a press release pre-feature launch
  // and no location was entered.
  if ($countrySelectedValue !== 'United States' || $stateSelectedValue === '') {
    hideStateDropdown();
  }

  // Form input required changes based on company_country value selected
  const handleChange = () => {
    $countrySelectedValue = $('#id_company_country :selected').val();
    // If United States is selected display the state select widget and make it required
    if ($countrySelectedValue === 'United States') {
      showStateDropdown();
      // Re-hide the dropdown when United States is unselected
    } else {
      hideStateDropdown();
    }
  };

  // Listen for change events on the country select widget
  $countrySelect.change(() => handleChange());

  // Listen for change events on the state select widget. This is necessary
  // in the event someone returns to edit and deselects a state to a blank variable but
  // leaves the country as 'United States'
  $stateSelect.change(() => handleChange());
});
